import React from "react";
import { Col, Card, CardBody, Table } from "reactstrap";
// components
import LoadingSkelentonTable from "../../../../components/loadingSkeletonTable";

const CARDS = [
  { key: 'show', label: 'Show', color: '#0ca30c' },
  { key: 'pending', label: 'Pendente', color: '#b8621f' },
  { key: 'noShow', label: 'No Show', color: '#d03b3b' },
  { key: 'total', label: 'Total', color: '#456091' },
];

export default function SummaryCards({
  guestCounts,
  groups = [],
  groupCounts = [],
  loadingGroupCounts = false,
}) {
  return (
    <>
      <section className="stock-card-container">
        {CARDS.map((card) => (
          <Col sm="3" key={card.key}>
            <Card className="card-stock" style={{ backgroundColor: card.color }}>
              <CardBody className="card-body-stock">
                <p>{card.label}</p>
                <div style={{ fontSize: '1.6rem', color: 'white', fontWeight: 'bold' }}>
                  {guestCounts[card.key]}
                </div>
              </CardBody>
            </Card>
          </Col>
        ))}
      </section>

      {(loadingGroupCounts || groupCounts.length > 0) && (
        <section style={{ paddingTop: '10px', paddingBottom: '10px' }}>
          <h5 className="mb-2">Check-ins por Grupo</h5>
          <div className="table-responsive">
            <Table className="table mb-0">
              <thead className="table-light">
                <tr>
                  <th>Grupo</th>
                  <th>Show</th>
                  <th>Pendente</th>
                  <th>No Show</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                {loadingGroupCounts ? (
                  <LoadingSkelentonTable lines={groups.length + 1} cols={5} />
                ) : (
                  groupCounts.map((group) => (
                    <tr key={group.id}>
                      <td>{group.text}</td>
                      <td>{group.show}</td>
                      <td>{group.pending}</td>
                      <td>{group.noShow}</td>
                      <td>{group.total}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          </div>
        </section>
      )}
    </>
  );
}
